import { MetaReducer, createReducer, on } from '@ngrx/store';

import { setDashboardFilter } from '@dashboards/store/actions/dashboard-filter.actions';
import { hydrationMetaReducer, patchInitialValue } from '@main-application/store/reducers/hydration-meta.reducer';

export const dashboardFilterFeatureKey = 'dashboardFilter';

export interface DashboardFilterState {
  assignee?: number;
}

export const initialState: DashboardFilterState = patchInitialValue(
  {
    assignee: null,
  },
  dashboardFilterFeatureKey
);

export const metaDashboardFilterReducers: Array<MetaReducer<any, any>> = [
  hydrationMetaReducer<DashboardFilterState>(dashboardFilterFeatureKey),
];

export const reducer = createReducer(
  initialState,
  on(setDashboardFilter, (state, action) => ({ ...state, ...action }))
);
